<template>
  <div class="ol-shared">
    <div class="map-item m-r-sm" id="leftMap">
      <div class="layer-select">
        <el-select v-model="leftLayerDate" class="nomal_select" popper-class="thSelect" size="small" placeholder="请选择"
          @change="leftLayerChange">
          <el-option v-for="item in timelines" :key="item.id" :label="item.productTimeCn" :value="item.id">
          </el-option>
        </el-select>
      </div>

      <!-- 图例 -->
      <transition enter-active-class="slide-in-right" leave-active-class="slide-out-right">
        <div class="ol-map-legends" v-show="legends.length > 0">
          <!-- <div class="ol-map-legend-unit">{{ unit }}</div> -->

          <div class="ol-map-legend" v-for="item in legends" :key="item.id">
            <div class="ol-map-legend-icon" :style="{ backgroundColor: item.color }"></div>
            <div class="ol-map-legend-label">{{ item.labelText }}</div>
          </div>
        </div>
      </transition>
    </div>

    <div class="map-item" id="rightMap">
      <div class="layer-select">
        <el-select v-model="rightLayerDate" class="nomal_select" popper-class="thSelect" size="small" placeholder="请选择"
          @change="rightLayerChange">
          <el-option v-for="item in timelines" :key="item.id" :label="item.productTimeCn" :value="item.id">
          </el-option>
        </el-select>
      </div>

      <!-- 图例 -->
      <transition enter-active-class="slide-in-right" leave-active-class="slide-out-right">
        <div class="ol-map-legends" v-show="legends.length > 0">
          <!-- <div class="ol-map-legend-unit">{{ unit }}</div> -->

          <div class="ol-map-legend" v-for="item in legends" :key="item.id">
            <div class="ol-map-legend-icon" :style="{ backgroundColor: item.color }"></div>
            <div class="ol-map-legend-label">{{ item.labelText }}</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Map from 'ol/Map'
import { getVectorContext } from 'ol/render'
import { defaults as defaultControls } from 'ol/control'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import VectorSource from 'ol/source/Vector'
import TileWMS from 'ol/source/TileWMS'
import GeoJSON from 'ol/format/GeoJSON'
import parseStyle from '../utils/style'
import { getTreeItem } from '@/utils/tools'
import { getBoundary, getProductResult } from '@/api/common'

export default {
  name: 'OlShared',

  props: {
    unit: {
      type: String,
      default: ''
    },

    legends: {
      type: Array,
      required: true
    },
    extent: {
      type: Array||String,
      default: ''
    },
    timelines: {
      type: Array,
      require: true
    },
    projectValue: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      leftLayer: null,
      leftLayerDate: this.timelines[0].id,
      rightLayer: null,
      rightLayerDate: this.timelines[1].id
    }
  },

  async mounted() {
    this.$waiting.show()
    const regions = JSON.parse(localStorage.getItem('regions'))
    let query = localStorage.getItem("query");
    if (query) {
      query = JSON.parse(query);
    }
    const regionId = query.regionId
    const { lon, lat, vertexBbox } = getTreeItem(regions, regionId)
    const extent = vertexBbox.slice(4, -1).split(',').map(item => item.split(' ')).reduce((pre, cur) => pre.concat(cur)).map(item => item * 1)
    const view = new View({
      projection: 'EPSG:4326',
      // center: [lon, lat],
      padding: [20, 20, 20, 20],
      maxZoom: 30,
      minZoom: 2
    })

    const { data: boundary } = await getBoundary(regionId)
    const features = new GeoJSON().readFeatures(boundary)
    const leftClipLayer = new VectorLayer({
      style: null,
      source: new VectorSource({ features })
    })

    const rightClipLayer = new VectorLayer({
      style: null,
      source: new VectorSource({ features })
    })

    const { layer: leftLayerName } = await getProductResult(this.timelines[0])
    const { layer: rightLayerName } = await getProductResult(this.timelines[1])

    this.leftLayer = new TileLayer({
      name: '成果图层',
      className: 'stamen',
      source: new TileWMS({
        url: process.env.VUE_APP_WMS,
        params: {
          LAYERS: leftLayerName,
          VERSION: '1.1.0',
          FORMAT: 'image/png',
          CQL_FILTER: `project_id=${this.projectValue} and data_date=${this.leftLayerDate}`
        }
      })
    })
    leftClipLayer.getSource().on('addfeature', () => this.leftLayer.setExtent(leftClipLayer.getSource().getExtent()))
    this.leftLayer.on('postrender', e => {
      const vectorContext = getVectorContext(e)
      e.context.globalCompositeOperation = 'destination-in'
      leftClipLayer.getSource().forEachFeature(feature => {
        vectorContext.drawFeature(feature, parseStyle({ fill: 'black' }))
      })
      e.context.globalCompositeOperation = 'source-over'
    })

    this.rightLayer = new TileLayer({
      name: '成果图层',
      className: 'stamen',
      source: new TileWMS({
        url: process.env.VUE_APP_WMS,
        params: {
          LAYERS: rightLayerName,
          VERSION: '1.1.0',
          FORMAT: 'image/png',
          CQL_FILTER: `project_id=${this.projectValue} and data_date=${this.rightLayerDate}`
        }
      })
    })
    rightClipLayer.getSource().on('addfeature', () => this.rightLayer.setExtent(rightClipLayer.getSource().getExtent()))
    this.rightLayer.on('postrender', e => {
      const vectorContext = getVectorContext(e)
      e.context.globalCompositeOperation = 'destination-in'
      rightClipLayer.getSource().forEachFeature(feature => {
        vectorContext.drawFeature(feature, parseStyle({ fill: 'black' }))
      })
      e.context.globalCompositeOperation = 'source-over'
    })

    // eslint-disable-next-line no-new
    new Map({
      target: 'leftMap',
      controls: defaultControls({
        zoom: false
      }),
      layers: [
        new TileLayer({
          name: '影像底图',
          source: new XYZ({
            url: 'http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=95b976bf1c852b261315ac5bcd2c3955'
          })
        }),
        new TileLayer({
          name: '边界图层',
          source: new TileWMS({
            url: process.env.VUE_APP_WMS,
            params: {
              layers: 'henan:high_field_land',
              VERSION: '1.1.0',
              FORMAT: 'image/png',
              STYLES: "henan:land_style",
              CQL_FILTER: `region_id=${regionId} or parent_id=${regionId}`
            }
          }),
          zIndex: 4
        }),
        this.leftLayer
      ],
      view
    })

    // eslint-disable-next-line no-new
    new Map({
      target: 'rightMap',
      controls: defaultControls({
        zoom: false
      }),
      layers: [
        new TileLayer({
          name: '影像底图',
          source: new XYZ({
            url: 'http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=95b976bf1c852b261315ac5bcd2c3955'
          })
        }),
        new TileLayer({
          name: '边界图层',
          source: new TileWMS({
            url: process.env.VUE_APP_WMS,
            params: {
              layers: 'henan:high_field_land',
              VERSION: '1.1.0',
              FORMAT: 'image/png',
              STYLES: "henan:land_style",
              CQL_FILTER: `region_id=${regionId} or parent_id=${regionId}`
            }
          }),
          zIndex: 4
        }),
        this.rightLayer
      ],
      view
    })

    view.fit(this.extent, { padding: [80, 20, 80, 20] })

    this.$waiting.hidden()
  },

  methods: {
    async leftLayerChange(payload) {
      let item = this.findTimeline(payload);
      this.$waiting.show()
      const details = await getProductResult(item);
      this.leftLayer.getSource().updateParams({
        LAYERS: details.layer,
        VERSION: '1.1.0',
        FORMAT: 'image/png',
        CQL_FILTER: `project_id=${this.projectValue} and data_date=${this.leftLayerDate}`
      })
      this.$waiting.hidden()
    },

    async rightLayerChange(payload) {
      let item = this.findTimeline(payload);
      this.$waiting.show()
      const details = await getProductResult(item);
      this.rightLayer.getSource().updateParams({
        LAYERS: details.layer,
        VERSION: '1.1.0',
        FORMAT: 'image/png',
        CQL_FILTER: `project_id=${this.projectValue} and data_date=${this.rightLayerDate}`
      })
      this.$waiting.hidden()
    },

    findTimeline(payload) {
      return this.timelines.find(item => item.id === payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.ol-shared {
  display: flex;
  height: 100%;

  .map-item {
    position: relative;
    flex: 1;
    border-radius: 6px;
  }

  .layer-select {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 2;
  }

  .ol-map-legends {
    position: absolute;
    right: 10px;
    bottom: 10px;
    display: flex;
    align-items: center;
    // min-width: 400px;
    height: 24px;
    font-size: 12px;
    padding: 0 10px;
    border: 1px solid rgba(30, 124, 104, 1);
    border-radius: 4px;
    backdrop-filter: blur(4px);
    background-color: rgba(4, 54, 35, 0.8);
    box-shadow: 0px 4px 10px 0px rgba(146, 159, 168, 0.4);
    z-index: 2;
  }

  .ol-map-legend-unit {
    flex: 1;
    text-align: center;
    color: #fff;
  }

  .ol-map-legend-all {
    height: 18px;
    font-size: 14px;
    color: #fff;
    margin-left: 10px;
    padding: 0 5px;
    border-radius: 2px;
    backdrop-filter: blur(4px);
    background-color: rgba(0, 125, 220, .8);
    cursor: pointer;
  }

  .ol-map-legend-toggle {
    margin-right: 0;
  }

  .ol-map-legend {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    // cursor: pointer;
  }

  .ol-map-legend-icon {
    width: 10px;
    height: 10px;
    margin-right: 4px;
    border-radius: 1px;
  }

  .ol-map-legend-label {
    color: #fff;
  }
}
</style>
